const TRUSTED_S3_HOSTNAME_PATTERN = /^([a-z0-9.-]+\.)?s3[.-][a-z0-9-]*\.amazonaws\.com$/;

/**
 * Validates that a presigned URL points to a trusted AWS S3 domain before making HTTP requests.
 * Prevents SSRF attacks by ensuring the URL uses HTTPS and its hostname ends with `.amazonaws.com`.
 * Must be called before any client-side HTTP request that uses a URL received from an API response.
 * @param {string} url - The presigned URL to validate.
 * @throws {Error} If the URL is malformed, not HTTPS, or targets a non-AWS hostname.
 */
export function validatePresignedS3Url(url) {
    let parsed;
    try {
        parsed = new URL(url);
    } catch {
        throw new Error('Invalid presigned URL: malformed URL');
    }

    if (parsed.protocol !== 'https:') {
        throw new Error('Invalid presigned URL: must use HTTPS');
    }

    if (!TRUSTED_S3_HOSTNAME_PATTERN.test(parsed.hostname)) {
        throw new Error('Invalid presigned URL: hostname is not a trusted AWS S3 domain');
    }

    return parsed.href;
}
